var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center" },
    [
      _c(
        "b-col",
        { attrs: { id: _vm.parentId } },
        [
          _c("document-classification-select", {
            attrs: {
              id: _vm.id,
              "select-dropdown-parent": "#" + _vm.parentId,
              classifications: _vm.DOCUMENT_TYPES_SELECT,
              loading: _vm.creating,
              disabled: _vm.creating,
              value: _vm.value.id,
              "loader-position": _vm.loaderPosition,
            },
            on: { change: _vm.handleClassificationSelection },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.allowManage
        ? _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-sm",
                  attrs: { variant: "white" },
                  on: { click: _vm.openManageDocumentTypesModal },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("documents.manageDocumentTypes")) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("manage-document-type-modal", {
        ref: "manageDocumentTypes",
        attrs: { "document-types-data": _vm.documentTypesData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }